import _ from 'lodash';
import React from 'react';
import {
  BusinessUnitFilter,
  DisciplineFilter,
  EmploymentTypeFilter,
  JobTitleFilter,
  MemberLevelFilter,
  LocationFilter,
  MemberBillableTypeFilter,
  MemberCostMethodFilter,
  MemberFilter,
  MemberInvitationStatusFilter,
  MemberStatusFilter,
  MemberTagFilter,
  MemberCertificationFilter,
  PracticeFilter,
  SecurityRoleFilter,
  SkillFilter,
} from '~/components/index';
import useFeatures from '~/hooks/useFeatures';
import FiltersGroup from './FiltersGroup';
import ReportPeriodFilter from './ReportPeriodFilter';

function MemberFiltersGroup({ filters, onChange }) {
  const features = useFeatures();

  return (
    <FiltersGroup
      label="Member Filters"
      filters={[
        filters.members,
        filters.memberEmploymentTypes,
        filters.memberBillableTypeId,
        filters.memberStatusId,
        filters.memberDisciplines,
        filters.memberJobTitles,
        filters.memberLevels,
        filters.memberBusinessUnits,
        filters.memberPractices,
        filters.memberManagers,
        filters.memberSkills,
        filters.memberCertifications,
        filters.memberTags,
        filters.memberLocations,
        filters.memberSecurityRoles,
        filters.memberCostMethods,
        filters.memberInvitationStatuses,
        filters.memberActivePeriod?.start,
        filters.memberActivePeriod?.end,
      ]}>
      <MemberFilter
        value={filters.members}
        placeholder="Member"
        onChange={({ target: { value } }) => onChange({ members: value })}
      />

      <EmploymentTypeFilter
        value={filters.memberEmploymentTypes}
        onChange={({ target: { value } }) => onChange({ memberEmploymentTypes: value })}
      />

      <MemberBillableTypeFilter
        value={filters.memberBillableTypeId}
        onChange={({ target: { value } }) => onChange({ memberBillableTypeId: value })}
      />

      {_.has(filters, 'memberStatusId') && (
        <MemberStatusFilter
          value={filters.memberStatusId}
          onChange={({ target: { value } }) => onChange({ memberStatusId: value })}
        />
      )}

      {features.disciplines && _.has(filters, 'memberDisciplines') && (
        <DisciplineFilter
          value={filters.memberDisciplines}
          placeholder="Member Discipline"
          onChange={({ target: { value } }) => onChange({ memberDisciplines: value })}
        />
      )}

      <JobTitleFilter
        value={filters.memberJobTitles}
        onChange={({ target: { value } }) => onChange({ memberJobTitles: value })}
      />

      {_.has(filters, 'memberLevels') && (
        <MemberLevelFilter
          value={filters.memberLevels}
          onChange={({ target: { value } }) => onChange({ memberLevels: value })}
        />
      )}

      {features.businessUnits && _.has(filters, 'memberBusinessUnits') && (
        <BusinessUnitFilter
          value={filters.memberBusinessUnits}
          placeholder="Member Business Unit"
          onChange={({ target: { value } }) => onChange({ memberBusinessUnits: value })}
        />
      )}

      {features.practices && _.has(filters, 'memberPractices') && (
        <PracticeFilter
          value={filters.memberPractices}
          placeholder="Member Practice"
          onChange={({ target: { value } }) => onChange({ memberPractices: value })}
        />
      )}

      <MemberFilter
        value={filters.memberManagers}
        placeholder="Member Manager"
        onChange={({ target: { value } }) => onChange({ memberManagers: value })}
      />

      {_.has(filters, 'memberSkills') && (
        <SkillFilter
          value={filters.memberSkills}
          placeholder="Member Skill"
          onChange={({ target: { value } }) => onChange({ memberSkills: value })}
        />
      )}

      {_.has(filters, 'memberCertifications') && (
        <MemberCertificationFilter
          value={filters.memberCertifications}
          placeholder="Member Certification"
          onChange={({ target: { value } }) => onChange({ memberCertifications: value })}
        />
      )}

      <MemberTagFilter
        value={filters.memberTags}
        onChange={({ target: { value } }) => onChange({ memberTags: value })}
      />

      <MemberCostMethodFilter
        value={filters.memberCostMethods}
        onChange={({ target: { value } }) => onChange({ memberCostMethods: value })}
      />

      {_.has(filters, 'memberLocations') && (
        <LocationFilter
          value={filters.memberLocations}
          placeholder="Member Location"
          onChange={({ target: { value } }) => onChange({ memberLocations: value })}
        />
      )}

      <MemberInvitationStatusFilter
        value={filters.memberInvitationStatuses}
        onChange={({ target: { value } }) => onChange({ memberInvitationStatuses: value })}
      />

      {_.has(filters, 'memberSecurityRoles') && (
        <SecurityRoleFilter
          placeholder="Member Security Role"
          value={filters.memberSecurityRoles}
          onChange={({ target: { value } }) => onChange({ memberSecurityRoles: value })}
        />
      )}

      {_.has(filters, 'memberActivePeriod') && (
        <ReportPeriodFilter
          placeholder="Member Active Range"
          value={filters.memberActivePeriod}
          onChange={({ target: { value } }) => onChange({ memberActivePeriod: value })}
        />
      )}
    </FiltersGroup>
  );
}

export default MemberFiltersGroup;
